module.exports = __webpack_public_path__ + "img/01MinersRefuge.cfade5cf.jpg";